import styled from 'styled-components'

import { E_Colors } from '@/helpers/colors'

interface T_OrganizationBannerProps {
  isBuyCertificate?: boolean
}

export const SC_CertificateTop = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const SC_CertificateOrganizationLogo = styled.div<T_OrganizationBannerProps>`
  ${({ isBuyCertificate }) =>
    !isBuyCertificate &&
  `
    padding: 5px;
    border-radius: 50%;
    background-color: ${E_Colors.White};
 `}
  flex-grow: 0;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    ${({ isBuyCertificate }) => `
      width: ${isBuyCertificate ? '48px' : '28px'};
      height: ${isBuyCertificate ? '48px' : '28px'};
    `}
    ${({ isBuyCertificate }) =>
    !isBuyCertificate &&
  `
    border-radius: 50%;
 `}
  }
`

export const SC_CertificateOrganizationTitle = styled.div`
  display: flex;
  flex-direction: column;

  > :first-child {
    color: ${E_Colors.TextPrimary};
    font-size: 17px;
  }

  > :last-child {
    color: ${E_Colors.Gray9C9CA1};
    font-size: 13px;
  }
`

export const SC_CertId = styled.div`
  background-color: ${E_Colors.Gray66};
  color: ${E_Colors.White};
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 12px;
`
